import { render, staticRenderFns } from "./OrderCostService.vue?vue&type=template&id=3cfdb43c"
import script from "./OrderCostService.vue?vue&type=script&lang=js"
export * from "./OrderCostService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports